var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-x-auto py-2 w-min"},[_c('div',{staticClass:"flex items-center gap-2 w-min"},[_c('router-link',{staticClass:"px-4 h-12 flex items-center text-sm whitespace-nowrap !no-underline !text-black rounded-md !shadow",class:{
        'pointer-events-none bg-gray-50': !_vm.pages.previous,
      },attrs:{"to":{
        path: _vm.to,
        query: {
          ..._vm.$route.query,
          page: _vm.pages.previous ? _vm.pages.previous : '',
        },
      }}},[_c('svg',{staticClass:"h-4 w-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M15 19l-7-7 7-7"}})])]),_vm._l((_vm.pagesDisplay),function(pageItem){return _c('div',{key:pageItem.index},[(pageItem.useRoute)?_c('router-link',{staticClass:"px-4 h-12 flex items-center text-sm whitespace-nowrap !no-underline !text-black rounded-md !shadow",class:{
          'bg-sky-600': _vm.currentPage === pageItem.route,
          'bg-sky-400': _vm.currentPage !== pageItem.route,
        },attrs:{"to":{
          path: _vm.to,
          query: {
            ..._vm.$route.query,
            page: pageItem.route
          }
        }}},[_vm._v(" "+_vm._s(pageItem.display)+" ")]):_c('div',[_c('input',{ref:"customPageInput",refInFor:true,staticClass:"px-2 h-12 w-16 flex items-center text-center whitespace-nowrap !no-underline !text-black rounded-md !shadow",attrs:{"placeholder":"..."},on:{"input":event => (_vm.customPage = event.target.value),"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onCustomPageInput()},"focusout":function($event){return _vm.onCustomPageInput()}}})])],1)}),_c('router-link',{staticClass:"px-4 h-12 flex items-center whitespace-nowrap !no-underline !text-black rounded-md !shadow",class:{
        'pointer-events-none bg-gray-50': !_vm.pages.next,
      },attrs:{"to":{
        path: _vm.to,
        query: {
          ..._vm.$route.query,
          page: _vm.pages.next
            ? _vm.pages.next
            : ''
        },
      }}},[_c('svg',{staticClass:"h-4 w-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M9 5l7 7-7 7"}})])])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }